module.exports = __webpack_public_path__ + "static/img/logo.603cf55f.png";